/**
 * Thin wrapper around the PostHog JS snippet loaded in public/index.html.
 * Keeps the rest of the app decoupled from the global and safe to call even
 * if PostHog failed to load (e.g. ad-blocker, no-JS, tests).
 */

function ph() {
  if (typeof window === "undefined") return null;
  return window.posthog || null;
}

/** Fire a named event with arbitrary properties. */
export function capture(event, properties = {}) {
  try {
    ph()?.capture?.(event, properties);
  } catch (e) {
    console.warn("[analytics] capture failed:", e);
  }
}

/** Associate the current anonymous visitor with a stable identifier (email). */
export function identify(distinctId, properties = {}) {
  if (!distinctId) return;
  try {
    ph()?.identify?.(distinctId, properties);
  } catch (e) {
    console.warn("[analytics] identify failed:", e);
  }
}

/** Merge the current anonymous session into an identified user (login). */
export function alias(newId) {
  if (!newId) return;
  try {
    ph()?.alias?.(newId);
  } catch (e) {
    console.warn("[analytics] alias failed:", e);
  }
}
